import React, { useState } from 'react';
import { Box, Typography, Grid, Paper, IconButton, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { CustomButton } from '../../../shared';
import { CloseIcon, FilterLinesIcon } from '../../../../assets';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../redux/reducers/fieldEngagementReducer';

const SearchUsingFilter = (props) => {

    const { } = props;
    const [filters, setFilters] = useState([]);
    const isFilter = false;
    const dispatch = useDispatch();
    const handleRemoveFilters = () => {
        console.log('handle remove filters called');
    }
    const handleSearch = (value) => {
        dispatch(actions.handleSearch({searchTerm: value}))
    }

    return (
        <Box className="flex-row-space-between-center">
            {isFilter && <Box className="flex-row-gap-8x-justify-content-center-align-items-center">
                <Box className="npi-table-filter-box">
                    <Typography className='text-fw-500-fs-14px-lh-20px'>
                        West, South, +1
                    </Typography>
                    <Box onClick={handleRemoveFilters} className="icon">
                        <CloseIcon color="#733567" width='10' height='10'/>
                    </Box>
                </Box>
                <Box>
                    <CustomButton
                        title="More Filters"
                        titleColor="#344054"
                        buttonColor="#FFFFFF"
                        icon={<FilterLinesIcon />}
                        customStyle={{ borderRadius: '8px' }}
                    />
                </Box>
            </Box> }

            {/* Search Box */}
            <Box>
                <Paper
                    component="form"
                    className='no-box-shadow'
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: { md: 200, lg: 250, xl: 320, }, border: '1px solid #D0D5DD', borderRadius: '8px' }}
                >
                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                        <SearchIcon />
                    </IconButton>
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search"
                        inputProps={{ 'aria-label': 'search google maps' }}
                        onChange={(e)=>handleSearch(e.target.value)}
                    />
                </Paper>
            </Box>

        </Box>
    )
}

export default SearchUsingFilter